import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxEnvelope = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M16.667 3.333H3.333c-.919 0-1.666.748-1.666 1.667v10c0 .92.747 1.667 1.666 1.667h13.334c.919 0 1.666-.748 1.666-1.667V5c0-.92-.747-1.667-1.666-1.667Zm0 1.667v.426L10 10.612 3.333 5.427V5h13.334ZM3.333 15V7.537l6.155 4.787a.828.828 0 0 0 1.024 0l6.155-4.787.001 7.463H3.333Z"
	})
});
export default SvgBxEnvelope;
